import buildScreenHeaderItems from '@/components/buildScreenHeaderItems'
import useHorizontalSafeAreaPadding from '@/lib/hooks/useHorizontalSafeAreaPadding'
import useWebBackButton from '@/lib/hooks/useWebBackButton'
import Terms from '@/modules/legal/Terms'
import { Stack } from 'expo-router'
import { ScrollView } from 'react-native'
import { useSafeAreaInsets } from 'react-native-safe-area-context'

export default function TermsPage() {
  const headerLeftItems = useWebBackButton('/forms')
  const insets = useSafeAreaInsets()
  const horizontalPadding = useHorizontalSafeAreaPadding()

  return (
    <>
      <Stack.Screen options={{ ...buildScreenHeaderItems({ left: headerLeftItems }) }} />
      <ScrollView
        contentInsetAdjustmentBehavior="automatic"
        contentContainerStyle={{ ...horizontalPadding, paddingBottom: insets.bottom }}
      >
        <Terms />
      </ScrollView>
    </>
  )
}
